// Single source for company facts and outbound links. Keep free of imports
// from seo modules to avoid cycles.
export const SEO_ORIGIN = 'https://www.horizon-tech.io'

export const COMPANY = {
  brand: 'Horizon Tech',
  legalName: 'Horizon Tech d.o.o.',
  locality: 'Sarajevo',
  countryCode: 'BA',
  email: 'hello@horizon-tech.io',
  logo: `${SEO_ORIGIN}/icon-512.png`,
  ogImage: `${SEO_ORIGIN}/clean-square.png`,
  // Google Business Profile NAP — must match the listing exactly.
  street: 'Maglajska 1',
  postalCode: '71000',
  phoneDisplay: '+387 61 180 078',
  phoneTel: '+38761180078',
  hours: 'Mo-Fr 09:00-17:00',
} as const

export const LINKS = {
  github: 'https://github.com/Horizon-Tech-doo',
  huggingface: 'https://huggingface.co/horizontechdoo',
  linkedin: 'https://www.linkedin.com/company/horizon-tech-d-o-o',
  arkived: 'https://arkived.app',
  arkivedRepo: 'https://github.com/Horizon-Tech-doo/arkived',
  tilelangIssue: 'https://github.com/tile-ai/tilelang/issues/3287',
  tilelangPr: 'https://github.com/tile-ai/tilelang/pull/3288',
  rss: '/rss.xml',
} as const

export const SOCIAL_PROFILES = [LINKS.github, LINKS.linkedin, LINKS.huggingface] as const
